import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=f790aa26&scoped=true&"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=f790aa26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f790aa26",
  null
  
)

component.options.__file = "NotFound.vue"
export default component.exports